module.exports = __webpack_public_path__ + "media/images/favicon-f3d01f5d7e0a2b74f0c748bfc2b76218.png";